import { createReducer } from '@reduxjs/toolkit';
import { actionManager, buildActionStatus } from '../utils';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import omit from 'lodash/omit';
import * as ca from './chimeActions';

const initialState = {
  activeSpeakers: [],
  externalMeetingId: '',
  externalMeetingName: '',
  meetingId: '',
  externalUserId: '',
  attendeeId: '',
  hostId: '',
  isHost: false,
  name: '',
  roster: {},
  upstreamVideoQuality: 0,
  audioVideo: null,
  currentAudioInputDevice: null,
  currentAudioOutputDevice: null,
  currentVideoInputDevice: null,
  audioInputDevices: null,
  audioOutputDevices: null,
  videoInputDevices: null,
  // hasMeetingBeenCreated: null, **DELETE
  meeting: null,
  meetingSession: null,
  meetingStatus: null,
  configuration: null,
  hasJoined: false,
  actionStatus: buildActionStatus(ca),
};

const chimeReducer = createReducer(initialState, {
  [ca.initAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: true, error: '' }),
  [ca.successAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: false, error: '' }),
  [ca.errorAction]: (state, { payload: { key, error } }) =>
    actionManager(state, key, { loading: false, error }),
  [ca.resetStateAction]: () => ({
    ...initialState,
  }),
  [ca.setExternalMeetingAction]: (state, { payload }) => ({
    ...state,
    externalMeetingId: payload.externalMeetingId,
    externalMeetingName: payload.externalMeetingName,
  }),
  [ca.setJoinInfoAction]: (state, { payload }) => {
    return {
      ...state,
      externalMeetingId: payload.externalMeetingId,
      externalUserId: payload.externalUserId,
      attendeeId: payload.attendeeId,
      hostId: payload.hostId,
      meetingId: payload.meetingId,
      name: payload.name,
      isHost: payload.hostId === payload.externalUserId,
      audioVideo: payload.audioVideo,
      meetingSession: payload.meetingSession,
      configuration: payload.configuration,
    };
  },
  [ca.setAudioDeviceListsAction]: (
    state,
    { payload: { audioInputDevices, audioOutputDevices, videoInputDevices } }
  ) => ({
    ...state,
    audioInputDevices: audioInputDevices,
    audioOutputDevices: audioOutputDevices,
    videoInputDevices: videoInputDevices,
  }),
  [ca.setAudioDeviceListAction]: (state, { payload: { key, devices } }) => ({
    ...state,
    [key]: devices,
  }),
  [ca.setCurrentDeviceAction]: (state, { payload: { deviceType, deviceValue } }) => {
    return {
      ...state,
      [deviceType]: deviceValue,
    };
  },
  [ca.removeRosterAttendeeAction]: (state, { payload: { attendeeId } }) => ({
    ...state,
    roster: omit(cloneDeep(state.roster), [attendeeId]),
  }),
  [ca.addRosterAttendeeAction]: (state, { payload: { attendeeId, value } }) => {
    if (attendeeId.endsWith('#content')) return state;

    let roster = cloneDeep(state.roster);
    roster[attendeeId] = value;

    return {
      ...state,
      roster,
    };
  },
  [ca.updateRosterAttributeAction]: (state, { payload: { attendeeId, key, value } }) => {
    if (attendeeId.endsWith('#content')) return state;

    let roster = cloneDeep(state.roster);

    set(roster, `${attendeeId}.${key}`, value);

    return {
      ...state,
      roster,
    };
  },
  [ca.setActiveSpeakersAction]: (state, { payload: { activeSpeakers } }) => ({
    ...state,
    activeSpeakers,
  }),
  [ca.setHasMeetingBeenCreatedAction]: (state, { payload: { isCreated, meeting } }) => {
    return {
      ...state,
      hasMeetingBeenCreated: isCreated,
      meeting,
    };
  },
  [ca.setMeetingStatusAction]: (state, { payload: { meetingStatus } }) => ({
    ...state,
    meetingStatus,
  }),
  [ca.setHasJoinedAction]: (state, { payload: { hasJoined } }) => ({
    ...state,
    hasJoined,
  }),
  [ca.setInitialParamsAction]: (state, { payload: { externalMeetingId, externalUserId } }) => ({
    ...state,
    externalMeetingId,
    externalUserId,
  }),
  [ca.setUpstreamVideoQualityAction]: (state, { payload: { id } }) => ({
    ...state,
    upstreamVideoQuality: id,
  }),
});

export default chimeReducer;
